<template>
  <div
    class="form-item"
    :class="{ 'form-item-inline': isInline, 'form-item-error': isRed }"
    :style="{ width: width, paddingLeft: labelWidth, backgroundColor: colorStyle }"
    :title="label + ':' + (value || '')"
  >
    <label v-if="!noLabel" :style="{ width: labelWidth }"> {{ displayL }} <b v-if="isRequired">*</b> </label>
    <el-select
      v-if="type == 'select'"
      ref="item"
      v-model="value"
      size="mini"
      filterable
      @blur="doHandleBlur"
      :placeholder="displayHolder"
      @focus="doHandleFocus"
    >
      <template v-if="Array.isArray(options)">
        <el-option v-for="op in options" :value="op" :key="op" :label="op || '--'"></el-option>
      </template>
      <template v-else>
        <el-option v-for="(v, k) in options" :value="k" :key="k" :label="v || '--'"></el-option>
      </template>
    </el-select>
    <el-select
      v-else-if="type == 'color'"
      v-model="value"
      filterable
      size="mini"
      @blur="doHandleBlur"
      :placeholder="displayHolder"
      class="color-select"
    >
      <el-option v-for="(op, k) in options" :value="k" :key="k" :label="op.word"></el-option>
    </el-select>
    <el-select
      v-else-if="type == 'multSelect'"
      v-model="value"
      size="mini"
      multiple
      :collapse-tags="collapseTags"
      filterable
      :placeholder="displayHolder"
      @remove-tag="doRemoveTag"
      @focus="doHandleFocus"
    >
      <template v-if="Array.isArray(options)">
        <el-option v-for="op in options" :value="op" :key="op" :label="op || '--'"></el-option>
      </template>
      <template v-else>
        <el-option v-for="(v, k) in options" :value="k" :key="k" :label="v || '--'"></el-option>
      </template>
    </el-select>
    <el-select
      v-else-if="type == 'createSelect'"
      v-model="value"
      size="mini"
      multiple
      :collapse-tags="collapseTags"
      filterable
      allow-create
      default-first-option
      :placeholder="displayHolder"
      @remove-tag="doRemoveTag"
    >
      <template v-if="Array.isArray(options)">
        <el-option v-for="op in options" :value="op" :key="op" :label="op || '--'"></el-option>
      </template>
      <template v-else>
        <el-option v-for="(v, k) in options" :value="k" :key="k" :label="v || '--'"></el-option>
      </template>
    </el-select>
    <el-input
      v-else-if="type == 'textarea'"
      type="textarea"
      :rows="2"
      :autosize="{ minRows: 2, maxRows: 5 }"
      v-model="value"
      :placeholder="displayHolder"
    >
    </el-input>
    <el-autocomplete
      v-else-if="type == 'autocomplete'"
      v-model="value"
      size="mini"
      :fetch-suggestions="fetchSuggestions"
      @blur="doHandleBlur"
      :placeholder="displayHolder"
    ></el-autocomplete>
    <el-date-picker
      v-else-if="type == 'date'"
      v-model="value"
      size="mini"
      type="date"
      :placeholder="displayHolder"
      @blur="doHandleBlur"
    >
    </el-date-picker>
    <el-date-picker
      v-else-if="type == 'datetime'"
      v-model="value"
      size="mini"
      type="datetime"
      :placeholder="displayHolder"
      @blur="doHandleBlur"
    >
    </el-date-picker>
    <el-date-picker
      v-else-if="type == 'month'"
      v-model="value"
      size="mini"
      type="month"
      format="yyyy.MM"
      :placeholder="displayHolder"
      @blur="doHandleBlur"
    >
    </el-date-picker>
    <el-date-picker
      v-else-if="type == 'year'"
      v-model="value"
      size="mini"
      type="year"
      :placeholder="displayHolder"
      @blur="doHandleBlur"
    >
    </el-date-picker>
    <el-checkbox-group v-else-if="type == 'checkbox'" v-model="value">
      <el-checkbox v-for="(op, k) in options" :label="op" :key="k"></el-checkbox>
    </el-checkbox-group>
    <el-switch v-else-if="type == 'switch'" v-model="value"></el-switch>
    <el-radio-group v-else-if="type == 'radio'" v-model="value">
      <el-radio v-for="(op, k) in options" :label="op" :key="k" border></el-radio>
    </el-radio-group>
    <el-slider v-else-if="type == 'range'" v-model="value" range :max="80"> </el-slider>
    <el-input v-else-if="type == 'disabledInput'" disabled size="mini" v-model="value" :placeholder="displayHolder" />
    <el-cascader
      v-else-if="type == 'cascader'"
      v-model="value"
      size="mini"
      :options="options"
      @change="doHandleChange"
      :show-all-levels="false"
      collapse-tags
      :props="{ multiple: true, expandTrigger: 'hover', checkStrictly: true, emitPath: false }"
      clearable
    ></el-cascader>
    <div v-else class="el-input el-input--mini">
      <input
        type="text"
        autocomplete="off"
        v-model="value"
        @blur="doHandleBlur"
        @keyup.enter="doHandleKeyupEnter"
        :placeholder="displayHolder"
        class="el-input__inner"
      />
    </div>
  </div>
</template>
<script>
const dateFormat = require('dateformat')
export default {
  props: {
    type: { type: String, default: 'input' },
    isInline: { type: Boolean, default: false },
    isRequired: { type: Boolean, default: false },
    width: { type: [String, Number], default: '100%' },
    labelWidth: { type: [String, Number], default: '60px' },
    label: String,
    displayLabel: String,
    placeholder: String,
    noLabel: Boolean,
    content: [Number, String, Array, Boolean],
    options: [Array, Object],
    collapseTags: { type: Boolean, default: false },
    handleDataChange: { type: Function, default: function() {} },
    handleFocus: {
      type: Function,
      default: function() {
        return true
      },
    },
    handleBlur: {
      type: Function,
      default: function() {
        return true
      },
    },
    removeTag: {
      type: Function,
      default: function() {},
    },
    box: String,
    index: Number,
  },
  data: function() {
    return {
      value: '',
      isRed: false,
    }
  },
  computed: {
    displayL: function() {
      return (this.displayLabel || this.label) + ':'
    },
    displayHolder: function() {
      return this.placeholder || this.displayLabel || this.label
    },
    colorStyle: function() {
      if (this.type == 'color' && this.value && this.options[this.value]) {
        return this.options[this.value].color
      }
      return '#fff'
    },
  },
  methods: {
    doHandleChange: function() {
      // console.log(this.value)
      if (this.value instanceof Date) {
        if (this.type === 'datetime') {
          this.value = dateFormat(this.value, 'yyyy-mm-dd HH:MM:ss')
        } else if (this.type === 'year') {
          this.value = dateFormat(this.value, 'yyyy')
        } else if (this.type === 'month') {
          this.value = dateFormat(this.value, 'yyyy.mm')
        } else {
          this.value = dateFormat(this.value, 'yyyy-mm-dd')
        }
      }
      let res = { label: this.label, content: this.value, box: this.box, index: this.index }
      this.handleDataChange(res)
    },
    doHandleBlur: function() {
      if (this.isRequired && !this.value) {
        this.isRed = true
      } else {
        this.isRed = false
      }
      let res = { label: this.label, content: this.value, box: this.box, index: this.index }
      this.handleBlur(res)
    },
    doHandleFocus: function() {
      this.handleFocus({ label: this.label })
      // if (!this.handleFocus({ label: this.label })) {
      //   this.$refs.item.blur()
      // }
    },
    doRemoveTag: function(tag) {
      this.removeTag({ label: this.label, tag: tag })
    },
    fetchSuggestions: function(qs, cb) {
      if (this.options) {
        let s = this.options.map(item => {
          return { value: item }
        })
        if (!qs) {
          cb(s)
        } else {
          cb(
            s.filter(c => {
              return c.value && c.value.toUpperCase().indexOf(qs.toUpperCase()) != -1
            }),
          )
        }
      }
    },
    doHandleKeyupEnter: function(event) {
      this.$emit('keyup-enter', event)
    },
  },
  watch: {
    value: function(newVal, oldVal) {
      if (newVal || (!newVal && oldVal)) {
        this.doHandleChange()
      }
    },
    content: function(newVal, oldVal) {
      if ((this.type == 'multSelect' || this.type == 'createSelect') && !newVal) {
        this.value = []
      } else {
        this.value = newVal
      }
    },
  },
  created: function() {
    this.value = this.content
  },
}
</script>
<style>
.form-item {
  display: inline-block;
  padding: 1px;
  vertical-align: middle;
}
.form-item > input,
.form-item > select,
.form-item > textarea,
.form-item > .el-select,
.form-item > .el-autocomplete,
.form-item > .el-input {
  width: 100%;
}
.form-item > label > b {
  color: #f00;
}
.form-item.form-item-inline {
  position: relative;
}
.form-item.form-item-inline > label {
  position: absolute;
  left: 0;
  height: 100%;
  line-height: 28px;
  display: flex;
  align-items: center;
  overflow: hidden;
  white-space: nowrap;
}
.form-item.form-item-error > input,
.form-item.form-item-error > select,
.form-item.form-item-error > textarea {
  border: 1px solid #f00;
}
.form-item.form-item-inline .el-slider__runway {
  margin: 11px 8px;
}
.form-item > .el-date-editor.el-input {
  width: 100%;
}
.form-item-btn {
  width: 100%;
  height: 26px;
  border-radius: 4px;
  line-height: 26px;
  background-color: rgba(64, 158, 255, 0.1);
  border: 1px solid rgba(64, 158, 255, 0.2);
  color: #01487e;
  text-align: center;
  cursor: pointer;
}
</style>
